import Vue from 'vue'
import {mapGetters,mapActions} from 'vuex'

import template from './_app-logo.pug'

const Logo = require('assets/images/logo.svg')

// @vue/component
export default Vue.extend({
  name: 'app-logo-partial-custom-vl',
  template: template(),

  data() {
    return {
      logo: Logo
    }
  },

  methods: {
    ...mapActions(['escucharAudio'])
  }
})
